import React from 'react'
import { Box, Flex, FlexProps } from 'rebass/styled-components'

import { LoadingBar } from '../Loading/Bar'
import { LoadingImage } from '../Loading/Image'

export interface SmartSelectLoadingContentProps extends FlexProps {
  variant?: string
}

export const SmartSelectLoadingContent = ({ variant, sx, ...props }: FlexProps): JSX.Element => {
  if (variant === 'image') {
    return (
      <Flex sx={{ flexWrap: 'wrap', gap: '12px', p: '0 20px 4px 20px', ...sx }} {...props}>
        {[...Array(3)].map((_item, index) => (
          <Flex key={index} sx={{ alignItems: 'center', gap: '15px' }}>
            <LoadingImage sx={{ width: '80px', height: 'auto', aspectRatio: '43 / 32' }} />
            <LoadingBar />
          </Flex>
        ))}
      </Flex>
    )
  }
  // 👇 default loading content is for a smart select of "single" item types
  return (
    <Box sx={{ p: '10px 20px 10px 20px', ...sx }} {...props}>
      <LoadingBar />
    </Box>
  )
}
